import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Loader from './common/Loader'
import Footer from './Footer'
import Header from './Header'

const PageContainer = ({ children, pageTitle = '', processing = false }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

            {processing && <Loader />}

            { pageTitle && <Helmet><title>{pageTitle} | Integrated Data Sharing Portal</title></Helmet> }

            <Header />

            <div style={{ flex: 1 }}>
                {children}
            </div>

            <Footer />
        </div>
    )
}

export default PageContainer